import { BUTTON_ICON_SIZE_MEDIUM_DESKTOP } from '@pkg/components/Sections/Profile/Buttons';
import { tokens as sheetTokens } from '@pkg/components/Sheet/tokens';

export const tokens = {
    action: {
        size: 32,
    },
    popover: {
        top: sheetTokens.spacing.tight * 5 + BUTTON_ICON_SIZE_MEDIUM_DESKTOP,
        right: sheetTokens.sheet.width.medium,
        radius: 10,
    },
};
